import { Linkedin, Instagram, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="relative bg-gradient-to-b from-gray-800 to-gray-900 backdrop-blur-md border-t border-[#d4a10d]/20 mt-auto overflow-hidden">
      <div className="absolute inset-0 grid-pattern opacity-5" />
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#d4a10d]/50 to-transparent" />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-6 py-8 sm:py-12">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8">
          {/* Company Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Company</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/contact" className="inline-flex items-center min-h-[44px] text-sm sm:text-base text-gray-300 hover:text-white transition-colors">
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/about" className="inline-flex items-center min-h-[44px] text-sm sm:text-base text-gray-300 hover:text-white transition-colors">
                  About
                </Link>
              </li>
              <li>
                <Link to="/blog" className="inline-flex items-center min-h-[44px] text-sm sm:text-base text-gray-300 hover:text-white transition-colors">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/canadian-real-estate" className="inline-flex items-center min-h-[44px] text-sm sm:text-base text-gray-300 hover:text-white transition-colors">
                  Canadian Real Estate
                </Link>
              </li>
              <li>
                <Link to="/faq" className="inline-flex items-center min-h-[44px] text-sm sm:text-base text-gray-300 hover:text-white transition-colors">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/glossary" className="inline-flex items-center min-h-[44px] text-sm sm:text-base text-gray-300 hover:text-white transition-colors">
                  AI Calling Glossary
                </Link>
              </li>
              <li>
                <Link to="/roi-calculator" className="inline-flex items-center min-h-[44px] text-sm sm:text-base text-gray-300 hover:text-white transition-colors">
                  ROI Calculator
                </Link>
              </li>
            </ul>
          </div>

          {/* Social Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Connect</h3>
            <div className="flex space-x-4">
              <a
                href="https://www.linkedin.com/in/foundernoahblanchard/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center min-h-[48px] min-w-[48px] text-gray-300 hover:text-[#d4a10d] transition-colors duration-300"
                aria-label="LinkedIn"
              >
                <Linkedin className="h-5 w-5" />
              </a>
              <a
                href="https://www.instagram.com/pointbreak.systems/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center min-h-[48px] min-w-[48px] text-gray-300 hover:text-[#d4a10d] transition-colors duration-300"
                aria-label="Instagram"
              >
                <Instagram className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Contact */}
          <div className="col-span-2 md:col-span-1 min-w-0">
            <h3 className="text-white font-semibold mb-4">Get in Touch</h3>
            <div className="space-y-3">
              <a
                href="mailto:noah@pointbreak.systems"
                className="inline-flex items-center min-h-[44px] break-all text-gray-300 hover:text-[#d4a10d] transition-colors duration-300"
              >
                noah@pointbreak.systems
              </a>
              <a
                href="tel:7096498492"
                className="flex items-center min-h-[44px] gap-2 text-gray-300 hover:text-[#d4a10d] transition-colors duration-300"
              >
                <Phone className="h-4 w-4" />
                (709) 649-8492
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-6 pt-6 border-t border-gray-600/20">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center">
            <p className="text-gray-300 text-sm">
              © {new Date().getFullYear()} Point Break Systems. All Rights Reserved.
            </p>
            <div className="flex items-center gap-4 mt-4 sm:mt-0">
              <p className="text-sm text-gray-400">
                Powered by AI Innovation
              </p>
              <Link to="/admin/login" className="text-xs text-gray-700 hover:text-gray-500 transition-colors">
                Admin
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
